import { render, staticRenderFns } from "./CustomerTodoContact.vue?vue&type=template&id=f9810576&scoped=true&"
import script from "./CustomerTodoContact.vue?vue&type=script&lang=js&"
export * from "./CustomerTodoContact.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTodoContact.vue?vue&type=style&index=0&id=f9810576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9810576",
  null
  
)

export default component.exports